'use strict';
var Pivot = (function () {
    function Pivot() {
    }
    Pivot.instance = function () {
        return new Pivot;
    };
    //scope: { twoWayBind: "=myTwoWayBind" };
    Pivot.prototype.link = function (scope, element, attrs) {
        var c3;
        //let windowEl: any = angular.element(this.$window);
        //windowEl.c3 = c3;
        var derivers = $.extend($.pivotUtilities.renderers, $.pivotUtilities.c3_renderers, $.pivotUtilities.d3_renderers, $.pivotUtilities.export_renderers);
        function updatePivotTable(newValue) {
            if (newValue) {
                var pivotData = scope.$eval(attrs.pivotData);
                if (pivotData) {
                    var pivotAttrs = $.extend({}, {
                        renderers: derivers,
                        rows: attrs.rows ? scope.$eval(attrs.rows) : undefined,
                        cols: attrs.cols ? scope.$eval(attrs.cols) : undefined,
                        aggregatorName: attrs.aggregatorName ? scope.$eval(attrs.aggregatorName) : undefined,
                        vals: attrs.vals ? scope.$eval(attrs.vals) : undefined,
                        rendererName: attrs.rendererName ? scope.$eval(attrs.rendererName) : undefined,
                        derivedAttributes: attrs.derivedAttributes ? scope.$eval(attrs.derivedAttributes) : undefined
                    });
                    angular.element(element)
                        .pivotUI(pivotData, pivotAttrs);
                }
            }
        }
        scope.$watchGroup([
            attrs.pivotData,
            attrs.rows,
            attrs.cols,
            attrs.aggregatorName,
            attrs.vals,
            attrs.rendererName,
            attrs.derivedAttributes
        ], updatePivotTable, true);
    };
    return Pivot;
}());
angular
    .module('application')
    .directive('pivotChart', Pivot.instance);

//# sourceMappingURL=pivot.js.map
